import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_CONFIG = {
  SERVICE_ID: 'your_service_id', // Replace with your EmailJS service ID
  TEMPLATE_ID_HIRE: 'template_hire_me', // Replace with your hire me template ID
  TEMPLATE_ID_CONTACT: 'template_contact', // Replace with your contact template ID
  PUBLIC_KEY: 'your_public_key' // Replace with your EmailJS public key
};

// Initialize EmailJS
emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);

export const sendHireEmail = async (formData) => {
  try {
    const templateParams = {
      to_name: 'Sabarisan P',
      from_name: formData.name,
      from_company: formData.company,
      from_email: formData.email,
      message: formData.message,
      subject: `🚀 Hiring Inquiry from ${formData.company}`,
      reply_to: formData.email,
      // Additional context for hiring emails
      email_type: 'Hiring Inquiry',
      timestamp: new Date().toLocaleString()
    };

    const response = await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID_HIRE,
      templateParams
    );

    console.log('Hire email sent successfully:', response);
    return { success: true, response };
  } catch (error) {
    console.error('Error sending hire email:', error);
    return { success: false, error };
  }
};

export const sendContactEmail = async (formData) => {
  try {
    const templateParams = {
      to_name: 'Sabarisan P',
      from_name: formData.name,
      from_email: formData.email,
      message: formData.message,
      subject: `💬 New Contact Message from ${formData.name}`,
      reply_to: formData.email,
      // Additional context for contact emails
      email_type: 'Contact Form',
      timestamp: new Date().toLocaleString()
    };

    const response = await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID_CONTACT,
      templateParams
    );

    console.log('Contact email sent successfully:', response);
    return { success: true, response };
  } catch (error) {
    console.error('Error sending contact email:', error);
    return { success: false, error };
  }
};

// For development/demo purposes - simulates email sending
export const sendEmailDemo = async (formData, type = 'contact') => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log(`Demo: ${type} email would be sent with data:`, formData);
      
      // Trigger demo dashboard update
      const emailEvent = new CustomEvent('emailDemo', {
        detail: {
          type,
          ...formData,
          timestamp: new Date().toLocaleString()
        }
      });
      window.dispatchEvent(emailEvent);
      
      resolve({ success: true, demo: true });
    }, 2000);
  });
};